import API from './config';

export interface LicenseStatus {
  has_active_license: boolean;
  subscriptions: Array<{
    id: string;
    status: string;
    current_period_end: number;
    cancel_at_period_end: boolean;
  }>;
  stripe_customer_id: string | null;
}

export function getLicenseStatus() {
  return API.get<{ data: LicenseStatus }>('licenses/status');
}

export function createCheckoutSession(priceId?: string) {
  return API.post<{
    data: {
      session_id: string;
      url: string;
    };
  }>('licenses/checkout', priceId ? { price_id: priceId } : {});
}

export function verifyCheckoutSession(sessionId: string) {
  return API.get<{
    data: {
      success: boolean;
      subscription_id: string | null;
    };
  }>(`licenses/checkout-success?session_id=${sessionId}`);
}

export function createPortalSession(returnUrl?: string) {
  return API.post<{
    data: {
      url: string;
    };
  }>('licenses/portal', returnUrl ? { return_url: returnUrl } : {});
}

